module.exports = __webpack_public_path__ + "static/cliff_front_albedo-4996b0f0b5d9acf0eff9ec5b5be816af.png";